<section class="external-scenes">
  @if (hasSearched() && !isSearching()) {
    <div class="external-scenes__counter">
      <span class="external-scenes__count">
        {{ 'EXTERNAL_SCENES.SCENES_COUNT' | translate: { count: rows().length } }}
      </span>
      <span class="external-scenes__progress">
        {{ 'EXTERNAL_SCENES.COUNTER' | translate: { inProgress: counters().inProgress, downloaded: counters().downloaded } }}
      </span>
    </div>
  }

  <div class="external-scenes__info">
    <i class="pi pi-info-circle external-scenes__info-icon"></i>
    <div>
      <div class="external-scenes__info-title">{{ 'EXTERNAL_SCENES.INFO_TITLE' | translate }}</div>
      <div class="external-scenes__info-subtitle">{{ 'EXTERNAL_SCENES.INFO_SUBTITLE' | translate }}</div>
    </div>
  </div>

  @if (errorKey(); as key) {
    <div class="external-scenes__alert external-scenes__alert--error" role="alert">{{ key | translate }}</div>
  }

  @if (truncatedProviderNames()) {
    <div class="external-scenes__alert external-scenes__alert--warning" role="status">
      {{ 'EXTERNAL_SCENES.WARNING_TRUNCATED' | translate: { providers: truncatedProviderNames() } }}
    </div>
  }

  @for (warning of providerWarnings(); track warning.provider) {
    <div class="external-scenes__alert external-scenes__alert--warning" role="status">
      {{ 'EXTERNAL_SCENES.WARNING_PROVIDER_ERROR' | translate: { provider: warning.provider, message: warning.message } }}
    </div>
  }

  @if (isSearching()) {
    <div class="external-scenes__state">
      <app-loading [loading]="true" width="48px" height="48px"></app-loading>
    </div>
  } @else if (!hasSearched()) {
    <p class="external-scenes__state external-scenes__state--hint">{{ 'EXTERNAL_SCENES.INITIAL_STATE' | translate }}</p>
  } @else if (isEmpty()) {
    @if (!errorKey()) {
      <p class="external-scenes__state external-scenes__state--hint">{{ 'EXTERNAL_SCENES.EMPTY_STATE' | translate }}</p>
    }
  } @else {
    <app-external-scenes-table
      [rows]="rows()"
      (previewClick)="onPreviewClick($event)"
      (loadClick)="onLoadClick($event)"></app-external-scenes-table>
  }
</section>

<app-external-scene-quick-view-dialog
  [row]="selectedRow()"
  [visible]="selectedRow() !== null"
  (closed)="onDialogClosed()"
  (loadClick)="onLoadClick($event)"></app-external-scene-quick-view-dialog>
